module.exports = __webpack_public_path__ + "img/attach.66b26f8b.svg";